import React, { useState } from 'react';
import { Radio, Input, Form } from 'antd';
import Grid from '@material-ui/core/Grid';

export default function RadioGroup(props) {

    const [value, setValue] = useState('')
    const [inputValue, setInputValue] = useState('')

    const onChangeRadio = (e, question) => {
        setValue(e.target.value)
        props.onChange(e, question)
    }

    const onChangeInputValue = (value, question) => {
        setInputValue(value);
        question.correctListAnswers[0].comment = value;
    }

    return (
        <div >
            <Radio.Group
                style={{
                    width: '600px',

                }}
                key={props.question.idQuestion}
                onChange={(e, q) => onChangeRadio(e, props.question)}
                value={value}
            >
                {props.listAnswers.map(i => {
                    return (<Radio key={i.idAnswer} value={i.idAnswer} style={{ fontSize: 16 }}>
                        {i.descriptionAnswer}

                    </Radio>)
                })}

            </Radio.Group>

            {
                value !== '' ?
                    props.listAnswers.find(i => i.idAnswer === value).isApplyComment === true ?
                        <Grid item>
                            <Form.Item
                                validateStatus={inputValue === '' ? "error" : "success"}
                                required
                                help={inputValue === '' ? 'Se requiere llenar este campo' : ''}
                            >
                                <Input
                                    maxLength={1000}
                                    style={{
                                        width: '600px',

                                    }}
                                    defaultValue={
                                        props.question.correctListAnswers !== undefined ?
                                            props.question.correctListAnswers[0].comment : 'no'}
                                    placeholder={'Comentario'}
                                    value={inputValue}
                                    onChange={e => onChangeInputValue(e.target.value, props.question)}
                                />
                            </Form.Item>
                        </Grid> : '' : ''}
        </div>

    )
}